import { LoadUserAdminOrganizationsPayload, LoadUserAdminOrganizationsResult } from '@ffncc/common';
import { createFunction } from '../../utilities/createFunction';

// eslint-disable-next-line max-len
export const loadUserAdminOrganizations = createFunction<LoadUserAdminOrganizationsPayload, LoadUserAdminOrganizationsResult>('loadUserAdminOrganizations');
